import { ExportIcon } from 'assets/icons/ExportIcon'
import { PlusIcon } from 'assets/icons/PlusIcon'
import { useNavigate } from 'react-router-dom'

import { Button, Flex, OutlineButton } from 'styling/GlobalStyles'

export const PurchaseRequestActions = () => {
  const navigate = useNavigate()
  return (
    <>
      <Button orange width='220' onClick={() => navigate('/procurement/create')}>
        Create purchase request
      </Button>
    </>
  )
}
